import { createFileRoute } from '@tanstack/react-router'
import { RegisterOrganizationPage } from '@/pages/authentication/ui/RegisterOrganizationPage'

export const Route = createFileRoute('/register-org')({
  component: RegisterOrganizationPage,
})
